import { render, staticRenderFns } from "./detail-banner.vue?vue&type=template&id=8b5e2dd0&scoped=true&"
import script from "./detail-banner.vue?vue&type=script&lang=js&"
export * from "./detail-banner.vue?vue&type=script&lang=js&"
import style0 from "./detail-banner.vue?vue&type=style&index=0&id=8b5e2dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5e2dd0",
  null
  
)

export default component.exports